import React from 'react';
import { BetStatus } from '@pascal/pascal-core';
import BetAmountSection from '../betAmountSection';
import CashOutBlock from '../cashOutBlock/index';

const BetPanel = ({
  t,
  isDemo,
  doBet,
  limits,
  cashOut,
  userBets,
  demoMode,
  precision,
  reportList,
  wageringOdd,
  betSections,
  activeFreeBet,
  currencyCode,
  freeBetsList,
  handleInputClick,
  disabledBetButton,
  currencySymbolOrCode,
  disabledCashOutButton,
  handleBetSectionsState,
  handleChangeInputValue,
}) => {
  return (
    <div className='fs-bet-action-panel'>
      {betSections.map(
        (section) =>
          section.isOpen && (
            <div className='fs-bet-action-panel-item' key={section.index}>
              <div className='fs-bet-panel'>
                {userBets[section.index]?.status === BetStatus.Pending && (
                  <CashOutBlock
                    t={t}
                    currencyCode={currencyCode}
                    bets={userBets}
                    userBet={userBets[section.index]}
                    precision={precision}
                    reportList={reportList}
                    demoMode={demoMode}
                    cashOut={cashOut}
                    index={section.index}
                    freeBetsList={freeBetsList}
                    activeFreeBet={activeFreeBet}
                    wageringOdd={wageringOdd}
                    disabledCashOutButton={disabledCashOutButton}
                    currencySymbolOrCode={currencySymbolOrCode}
                  />
                )}
                {userBets[section.index]?.status !== BetStatus.Pending && (
                  <BetAmountSection
                    bet={section.betAmount}
                    doBet={doBet}
                    index={section.index}
                    limits={limits}
                    isDemo={isDemo}
                    section={section}
                    betSections={betSections}
                    wageringOdd={wageringOdd}
                    handleBetSectionsState={handleBetSectionsState}
                    handleChangeInputValue={handleChangeInputValue}
                    disabledBetButton={disabledBetButton}
                    handleInputClick={handleInputClick}
                    activeFreeBet={activeFreeBet}
                  />
                )}
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default BetPanel;
